export default {
    COM_DISPUTA: {texto: 'Com Disputa', valor: 'COM_DISPUTA'},
    SEM_DISPUTA: {texto: 'Sem Disputa', valor: 'SEM_DISPUTA'},
}
